import { useMutation } from "@apollo/client/react"
import React, { useState } from "react"

import { UpdateCustomerContactDocument } from "@/graphql/graphql"
import { showErrorToast } from "@/shared/toast"

import CustomerDetailsEdit from "./edit"
import CustomerDetailsView from "./view"

interface CustomerDetailsProps {
  customer: any
  customerContact: any
  onUpdate?: () => void
}

const CustomerDetails: React.FC<CustomerDetailsProps> = ({ customer, customerContact, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [updateCustomerContact, { loading }] = useMutation(UpdateCustomerContactDocument)

  const handleSubmit = async (values: any) => {
    try {
      const result = await updateCustomerContact({
        variables: {
          customerContactId: customerContact.id,
          name: values.name,
          email: values.email || null,
          phone: values.phone || null,
        },
        refetchQueries: ["getCustomerByContact"],
        awaitRefetchQueries: true,
      })

      if (result.data?.updateCustomerContact?.success) {
        setIsEditing(false)
        onUpdate?.()
      }
    } catch (error) {
      showErrorToast("Failed to update contact details. Please try again.")
      console.error("Failed to update customer contact:", error)
    }
  }

  if (isEditing) {
    return (
      <div data-testid="panel-clients-modal-details-container">
        <CustomerDetailsEdit
          customer={customer}
          customerContact={customerContact}
          onSubmit={handleSubmit}
          onCancel={() => setIsEditing(false)}
          loading={loading}
        />
      </div>
    )
  }

  return (
    <div data-testid="panel-clients-modal-details-container">
      <CustomerDetailsView customer={customer} customerContact={customerContact} onEdit={() => setIsEditing(true)} />
    </div>
  )
}

export default CustomerDetails
